const plural =
  (singular: string, multiple?: string) =>
  (count: number): string =>
    Number(count) === 1 ? singular : multiple || `${singular}s`

export default plural
